import { Card, CardContent } from "./ui/card";
import { fmtCurrency } from "../lib/format";
import { cn } from "../lib/utils";

export const TotalsCard = ({ label, value, helper, testId, accent = false }) => {
  const negative = Number(value) < 0;
  return (
    <Card className={cn("shadow-sm", accent && "border-primary/30 bg-accent/40")}>
      <CardContent className="p-4 sm:p-5">
        <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</p>
        <p
          data-testid={testId}
          className={cn(
            "mt-1 font-mono text-2xl font-semibold tabular-nums sm:text-3xl",
            negative ? "text-red-600" : "text-foreground"
          )}
        >
          {fmtCurrency(value)}
        </p>
        {helper && <p className="mt-1 text-xs text-muted-foreground">{helper}</p>}
      </CardContent>
    </Card>
  );
};
